export const playIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="currentColor" d="M8 16A8 8 0 1 0 8-.001 8 8 0 0 0 8 16m3.207-7.667a.61.61 0 0 1-.394.547L6.76 10.913a.9.9 0 0 1-.353.087.6.6 0 0 1-.327-.093.67.67 0 0 1-.307-.607V6.367a.7.7 0 0 1 .307-.614.67.67 0 0 1 .667 0l4.06 2a.67.67 0 0 1 .4.58"/></svg>`,
    name: 'play'
};